// extracted by mini-css-extract-plugin
module.exports = {"suggest":"styles_suggest__2BJu9","option":"styles_option__3VnR5","keyboard":"styles_keyboard__XCd7k"};